import { useEffect, useState } from 'react';
import LoadingSpinner from '../loading-spinner/loading-spinner';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface PageNotFoundProps {}

export function PageNotFound(props: PageNotFoundProps) {
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation(['common']);
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  if (isLoading) {
    return <LoadingSpinner spinnerId="page-not-found-loading" />;
  }

  return (
    <div className="min-h-full bg-white px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
      <div className="mx-auto max-w-max">
        <main className="sm:flex">
          <p className="text-4xl font-bold tracking-tight text-color-primary-0 sm:text-5xl">
            404
          </p>
          <div className="sm:ml-6">
            <div className="sm:border-l sm:border-gray-200 sm:pl-6">
              <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
                {t('Page not found')}
              </h1>
              <p className="mt-1 text-base text-gray-500">
                <Trans i18nKey="check_url">
                  Please check the URL in the address bar and try again, or
                  navigate to the{' '}
                  <Link to="/" className="text-blue-600">
                    home page
                  </Link>
                  .
                </Trans>
              </p>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default PageNotFound;
